import clsx from "clsx";
import {
  forwardRef,
  type HTMLAttributes,
  type TdHTMLAttributes,
  type ThHTMLAttributes,
} from "react";

const Table = forwardRef<HTMLTableElement, HTMLAttributes<HTMLTableElement>>(
  ({ className, ...props }, ref) => {
    return (
      <div className="overflow-x-auto shrink-0 relative scrollbar-thin rounded-3xl border border-black-200">
        <table
          ref={ref}
          className={clsx(
            "border-separate border-spacing-0 w-full table-auto",
            className,
          )}
          {...props}
        />
      </div>
    );
  },
);
Table.displayName = "Table";

const TableHead = forwardRef<
  HTMLTableCellElement,
  ThHTMLAttributes<HTMLTableCellElement>
>(({ className, ...props }, ref) => (
  <th
    ref={ref}
    className={clsx(
      "text-left text-nowrap text-button-xs text-black-500 p-2.5 first:pl-3 h-10 border-b border-black-200",
      className,
    )}
    {...props}
  />
));
TableHead.displayName = "TableHead";

const TableRow = forwardRef<
  HTMLTableRowElement,
  ThHTMLAttributes<HTMLTableRowElement>
>(({ className, onClick, ...props }, ref) => (
  <tr
    ref={ref}
    onClick={onClick}
    className={clsx(
      "group/table-row",
      "data-[state=selected]:bg-purple-50 data-[state=selected]:hover:bg-purple-50",
      onClick && "hover:bg-black-50 cursor-pointer",
      className,
    )}
    {...props}
  />
));
TableRow.displayName = "TableRow";

const TableCell = forwardRef<
  HTMLTableCellElement,
  TdHTMLAttributes<HTMLTableCellElement>
>(({ className, ...props }, ref) => {
  return (
    <td
      ref={ref}
      className={clsx(
        "first:pl-3 text-left last:text-right",
        "p-2.5 text-button-xs border-b border-black-200",
        "group-last/table-row:!border-b-0",
        className,
      )}
      {...props}
    />
  );
});
TableCell.displayName = "TableCell";

export { Table, TableCell, TableHead, TableRow };
